import React, { Fragment } from 'react'
import { useTranslation } from '../../hooks/useTranslation';

function QuantityButtonsComponent({ setValue, getValues, availableQuantity, dailyInventoryForm, errorMessage }) {
    const { t } = useTranslation();
    const increaseAllowed = () => {
        return getValues('dailyInventoryDate') && ((parseInt(getValues('dailyInventoryQuantity'))) < availableQuantity);
    }
    const decreaseAllowed = () => {
        return getValues('dailyInventoryDate') && (parseInt(getValues('dailyInventoryQuantity')) - 1) >= 0;
    }

    return (
        <Fragment>
            <div className='d-flex justify-content-between align-items-center'>
                <span>{t("Quantity")}</span>
                <div className='quantity-buttons'>
                    <button type='button'
                        disabled={!increaseAllowed()}
                        onClick={() => increaseAllowed() ? setValue('dailyInventoryQuantity', parseInt(getValues('dailyInventoryQuantity')) + 1) : null}>+</button>
                    <div className="quantity">
                        <input
                            className="d-block"
                            type="number"
                            min={1}
                            max={availableQuantity}
                            defaultValue={1}
                            disabled={!getValues('dailyInventoryDate')}
                            {...dailyInventoryForm('dailyInventoryQuantity', {
                                pattern: {
                                    value: /^[0-9]*$/,
                                    message: t("NumberValidationMsg")
                                },
                                min: {
                                    value: 1,
                                    message: t("MinValueValidationMsg")
                                },
                                max: {
                                    value: availableQuantity,
                                    message: t("MaxValueValidationMsg")
                                }
                            })}
                        />
                    </div>
                    <button type='button'
                        disabled={!decreaseAllowed()}
                        onClick={() => decreaseAllowed() ? setValue('dailyInventoryQuantity', parseInt(getValues('dailyInventoryQuantity')) - 1) : null}>-</button>
                </div>
            </div>
            <div className='d-flex justify-content-end mt-2'>
                {!!errorMessage && !!getValues('dailyInventoryDate') && (
                    <span role="alert" className="error">{errorMessage}</span>
                )}
            </div>
        </Fragment>
    )
}

export default QuantityButtonsComponent